import styled from 'styled-components'
import { TypeFiesta } from '@at/design-system-foundation'

export const InfoBannerHeader = styled(TypeFiesta)`
    width: calc(100% - 8px);
    padding: 8px 0;
`
